export type ReportVizId =
    | 'domain-rankings'
    | 'variance'
    | 'tier-segmentation'
    | 'domain-correlation'
    | 'pre-assessment-completion'
    | 'sessions-completed-threshold'
    | 'growth'
    | 'survey-submissions';

export type ReportVizOption = {
    id: ReportVizId;
    label: string;
    endpoint: string;
    group: string;
};

export const REPORT_VIZ_CATALOG: ReportVizOption[] = [
    { id: 'domain-rankings', label: 'Domain rankings', endpoint: '/api/reports/domain-rankings/', group: 'Team Report' },
    { id: 'variance', label: 'Score variance', endpoint: '/api/reports/variance/', group: 'Team Report' },
    { id: 'tier-segmentation', label: 'Tier segmentation', endpoint: '/api/reports/tier-segmentation/', group: 'Team Report' },
    { id: 'domain-correlation', label: 'Domain correlation', endpoint: '/api/reports/domain-correlation/', group: 'Team Report' },
    { id: 'growth', label: 'Growth by domain', endpoint: '/api/reports/growth/week/', group: 'Team Report' },
    { id: 'pre-assessment-completion', label: 'Pre-assessment completion', endpoint: '/api/reports/pre-assessment-completion/', group: 'Session Engagement' },
    { id: 'sessions-completed-threshold', label: 'Sessions completed', endpoint: '/api/reports/sessions-completed-threshold/', group: 'Session Engagement' },
    { id: 'survey-submissions', label: 'Survey submissions', endpoint: '/api/reports/survey-submissions/', group: 'Surveys' },
];

export const REPORT_VIZ_BY_ID: Record<ReportVizId, ReportVizOption> = REPORT_VIZ_CATALOG.reduce(
    (acc, opt) => {
        acc[opt.id] = opt;
        return acc;
    },
    {} as Record<ReportVizId, ReportVizOption>,
);

export const PRESET_TEAM: ReportVizId[] = [
    'domain-rankings',
    'variance',
    //    'tier-segmentation',
    //    'domain-correlation',
    'growth',
];

export const PRESET_SESSION_ENGAGEMENT: ReportVizId[] = [
    'pre-assessment-completion',
    'sessions-completed-threshold',
];

export function parseVizQuery(raw: string | null): ReportVizId[] {
    if (!raw) return [];
    const valid = new Set(REPORT_VIZ_CATALOG.map((o) => o.id));
    const seen = new Set<ReportVizId>();
    const ordered: ReportVizId[] = [];
    for (const part of raw.split(',')) {
        const id = part.trim() as ReportVizId;
        if (valid.has(id) && !seen.has(id)) {
            seen.add(id);
            ordered.push(id);
        }
    }
    // Render in catalog order regardless of query order
    return REPORT_VIZ_CATALOG.map((o) => o.id).filter((id) => seen.has(id));
}

export function serializeVizQuery(ids: ReportVizId[]): string {
    return REPORT_VIZ_CATALOG.map((o) => o.id).filter((id) => ids.includes(id)).join(',');
}
